module.exports = __webpack_public_path__ + "img/metal_q@2x.78f9be69.png";